import crypto from 'crypto-browserify'
import { algorithm } from './algorithm'
import { key, keyAsync } from './key'

// Versión síncrona (puede bloquear UI la primera vez)
export const encrypt = (text) => {
  const iv = crypto.randomBytes(16)
  const cipher = crypto.createCipheriv(algorithm, key(), iv)
  const encrypted = cipher.update(text)
  const result = Buffer.concat([encrypted, cipher.final()]).toString('hex')
  return `${iv.toString('hex')}:${result}`
}

// Versión asíncrona (recomendada - no bloquea el UI)
export const encryptAsync = async (text) => {
  const derivedKey = await keyAsync()
  const iv = crypto.randomBytes(16)
  const cipher = crypto.createCipheriv(algorithm, derivedKey, iv)
  const encrypted = cipher.update(text)
  const result = Buffer.concat([encrypted, cipher.final()]).toString('hex')
  return `${iv.toString('hex')}:${result}`
}

